import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ApiConstants } from 'src/app/core/constants/api.constants';
import { TuwaiqConfig } from 'src/app/core/constants/tuwaiq.config';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';
import { TuwaiqUtil } from 'src/app/core/TuwaiqUtil';
import { SessionExpiredComponent } from 'src/app/shared/components/sessionExpired/sessionExpired/session-expired.component';
import { callRecordTableConstants } from '../constants/callRecordTable.constants';
import { CallRecordTableColumns } from '../model/call-record-table-columns.model';

@Injectable({
    providedIn: 'root'
})
export class CallRecordModuleService {
    isExpiredSession: any;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private loggedInUserService: LoggedInUserService
    ) {}

    getCallRecordList(parameters = {}) {
        let api = this.handleSectionFilter(ApiConstants.CALL_RECORD_LIST);

        const body = this.buildQueryParams(parameters);

        return this.http.get(api, { params: body, observe: 'response' }).pipe(
            map(response => {
                let responseData = response;

                if (response.status === 200) {
                    TuwaiqUtil.convertObjectKeysToCamelCase(response);
                    return responseData;
                }
                //if 204 status, indicating there is no user profiles, return null
                if (response.status === 204) {
                    return (responseData = null);
                }
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    createCallRecord(callRecord, parameters?) {
        const api = ApiConstants.CALL_CREATE;
        return this.http.post(api, callRecord, { params: parameters }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    getSmsCallDetails(callRecordId) {
        let api = ApiConstants.SMS_CALL_RECORD_DETAILS.replace('{callRecordId}', callRecordId.toString());

        return this.http.get(api).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }

    resendSmsNotification(callRecordId: number) {
        const api = ApiConstants.SMS_RESEND_RETRY.replace('{callRecordId}', callRecordId.toString());
        
        return this.http.post(api, {}).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    getByIdCallRecord(callRecordId) {
        const api = ApiConstants.VIEW_CALL_READ_ONLY.replace('{callRecordId}', callRecordId.toString());

        return this.http.get(api).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    searchUserCallRecord(querySearch) {
        const api = ApiConstants.SEARCH_CALL_RECORD;

        let parameters = new HttpParams();

        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.SEARCH_QUERY, querySearch);
        return this.http.get(api, { params: parameters }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    handleAttachmentObject(attachmentList, action) {
        return attachmentList.map(attachment => ({
            checksum: TuwaiqConfig.ATTACHMENT_CHECKSUM,
            'content-type': attachment.type,
            key: attachment.key,
            name: attachment.name,
            size: attachment.size,
            action: action
        }));
    }
    convertResponseToTableData(response: any) {
        return new CallRecordTableColumns(
            response.id,
            response?.employee?.name,
            response?.employee?.email,
            response?.employee?.image,
            response?.requesterName,
            response?.requesterData?.email,
            response?.requesterData?.image,
            response?.client?.id,
            response?.client?.name,
            response?.service?.id,
            response?.service?.name,
            response?.service?.sectionId,
            response.status,
            response.createdAt,
            response?.mobilePhoneNumber,
            response?.containingSms,
            response?.code,
            response?.notificationStatus
            
        );
    }
    getTableColumns(requestObjectName: string) {
        // return reportTableConstants[requestObjectName].tableColumn;

        const tableConfig = callRecordTableConstants[requestObjectName];
        if (!tableConfig || !tableConfig.tableColumn) {
            console.warn(`No table configuration found for: ${requestObjectName}`);
            return []; // Return an empty array or handle as needed
        }
        return tableConfig.tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = callRecordTableConstants[requestObjectName];
        if (!displayColumns || !displayColumns.tableColumn) {
            console.warn(`No table configuration found for: ${requestObjectName}`);
            return []; // Return an empty array or handle as needed
        }
        return displayColumns.tableColumn.map(c => c.columnDef);
    }

    buildQueryParams(source: Object): HttpParams {
        let target: HttpParams = new HttpParams();
        Object.keys(source).forEach((key: string) => {
            const value: string | number | boolean | Date | Object = source[key];
            if (typeof value !== 'undefined' && value !== null) {
                target = target.append(key, value.toString());
            }
        });
        return target;
    }
    public getAllCreators(): Observable<any[]> {
        let api = ApiConstants.CALL_RECORD_CREATOR;
        return this.http.get(api).pipe(map((response: { data: any[]; meta: any }) => TuwaiqUtil.convertObjectKeysToCamelCase(response.data)));
    }
    public getAllClient(): Observable<any[]> {
        let api = ApiConstants.CALL_RECORD_CLIENT;
        return this.http.get(api).pipe(map((response: { data: any[]; meta: any }) => TuwaiqUtil.convertObjectKeysToCamelCase(response.data)));
    }
    public getAllRequester(): Observable<any[]> {
        let api = ApiConstants.CALL_RECORD_REQUESTER;
        return this.http.get(api).pipe(map((response: { data: any[]; meta: any }) => TuwaiqUtil.convertObjectKeysToCamelCase(response.data)));
    }
    public getAllService(): Observable<any[]> {
        let api = ApiConstants.CALL_RECORD_SERVICE;
        return this.http.get(api).pipe(map((response: { data: any[]; meta: any }) => TuwaiqUtil.convertObjectKeysToCamelCase(response.data)));
    }
    getServiceList(clientId) {
        const api = ApiConstants.CLIENT_SERVICE_CALL_LIST.replace('{clientId}', clientId.toString());

        return this.http.get(api).pipe(
            map(response => {
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
 
    private handleSectionFilter(url: string): string {
        if ((this.loggedInUserService.isAdminOrSuperAdmin() ||this.loggedInUserService.isGeneralManager()) && this.loggedInUserService.viewAsSection()) {
            const link = new URL(url);
            link.searchParams.set(TuwaiqConfig.REQUEST_QUERY_PARAMS.SECTION_FILTER, this.loggedInUserService.viewAsSection());
            return link.toString();
        }
        return url;
    }

    /** Error Handling method */
    errorHandler(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            // this.authService.logout()
            this.handleSessionExpired();
        } else if (errorResponse.error && errorResponse.error['errors']) {
            return throwError(() => errorResponse.error['errors'][0]);
        }
        return throwError(() => 'An error occurred; please try again later.');
    }

    //TEMP:
    errorListHandler(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            // this.authService.logout()
            this.handleSessionExpired();
        } else if (errorResponse.error && errorResponse.error['errors']) {
            return throwError(() => errorResponse.error['errors']);
        }
        return throwError(() => 'An error occurred; please try again later.');
    }

    handleSessionExpired() {
        if (!this.isExpiredSession) {
            this.dialog.open(SessionExpiredComponent, {
                width: '412px',
                disableClose: true
            });
            this.isExpiredSession = true;
        }
    }
}
